export type CostModels = {
  pv1?: number[];
  pv2?: number[];
  pv3?: number[];
  key?: number[];
};

export function parseCostModels(costModels: Map<number, any>): CostModels {
  return {
    pv1: costModels.get(0) ? costModels.get(0) : undefined,
    pv2: costModels.get(1) ? costModels.get(1) : undefined,
    pv3: costModels.get(2) ? costModels.get(2) : undefined,
    key: costModels.get(3) ? costModels.get(3) : undefined,
  };
}
